import { createRootSelector } from "../../../utils/createSelector.js";
export const gridColumnMenuSelector = createRootSelector(state => state.columnMenu);